import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import GrowingStars from '../components/GrowingStars';
import growingStarsImg from '../assets/icons/growing-stars.webp';

const GrowingStarsPage = () => {
  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }, []);
  return (
    <div className="growing-stars-page">
      <Navigation />

      <section className="bg-sand pt-20 pb-8">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="font-serif text-5xl lg:text-6xl mb-6 text-indigoDeep page-header-title">
              <img src={growingStarsImg} alt="Growing Stars" className="page-header-icon" />
              <span>Growing Stars</span>
            </h1>
            <p className="text-xl text-grayWarm max-w-3xl mx-auto leading-relaxed">
              Astrology readings designed to guide, support, and nurture young minds as they grow. Unlock personalised insights into your child’s nature, learning style, emotional patterns and relationship dynamics.
            </p>
          </div>
        </div>
      </section>

      <div className="py-16 bg-sand">
        <div className="max-w-7xl mx-auto px-6">
          <GrowingStars />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GrowingStarsPage;
